import { mapActions } from "vuex";
import { materialFamilyMixin } from "@/mixins/management/materialFamilyMixin";

export const customFieldsMixin = {

  mixins: [materialFamilyMixin],

  data() {
    return {
      forms: [],
      lists: [],
      customLists: [],
      list: [],
      alternativeMaterialFamiliesList: []
    };
  },

  computed: {
    /**
     * List of objects and material families
     * @return {Array}
     */
    objectsAndMaterialFamilies() {
      let familyOptions = [];
      let list = this.$store.getters.optionLists_materialFamily;
      if (list && list.length > 0) {
        list.forEach(option => {
          familyOptions.push({
            id: option.code,
            label: this.getFamilyName(option.name)
          });
        });
      } else if (this.alternativeMaterialFamiliesList.length === 0) {
        this.getMaterialFamilies();
        this.loading = false;
        return this.alternativeMaterialFamiliesList;
      } else if (this.alternativeMaterialFamiliesList.length > 0) {
        return this.alternativeMaterialFamiliesList;
      }
      return familyOptions;
    },

    /**
     * List of possible field types
     * @return {Array}
     */
    fieldTypes() {
      return [
        {
          id: "text",
          label: "Text"
        },
        {
          id: "textarea",
          label: "Text Area"
        },
        {
          id: "float",
          label: "Float"
        },
        {
          id: "int",
          label: "Integer"
        },
        {
          id: "checkbox",
          label: "Checkbox"
        },
        {
          id: "select",
          label: "Select",
          disabled: true
        },
        {
          id: "multiselect",
          label: "Multi-Select",
          disabled: true
        },
        {
          id: "datetime",
          label: "Datetime"
        },
        {
          id: "date",
          label: "Date"
        },
        /*
        {
          id: "url",
          label: "URL"
        },
        {
          id: "file",
          label: "File"
        },
        */
        {
          id: "photo",
          label: "Photo"
        },
      ];
    },

    /**
     * Possible field size values
     *
     * @returns {Array}
     */
    customFieldSizeOptions() {
      return [
        {
          id: "small",
          label: this.$i18n.t("Small")
        },
        {
          id: "medium",
          label: this.$i18n.t("Medium")
        },
        {
          id: "large",
          label: this.$i18n.t("Large")
        }
      ];
    }
  },

  mounted() {
    this.getForms();
  },

  methods: {
    ...mapActions([
      "FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS",
      "fetchCustomLists",
      "fetchCustomListByUuid",
      "GET_LIST"
    ]),

    async getForms() {
      try {
        let forms = await this.FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS(
          "custom_fields_available"
        );

        let finalForm = [];
        for (let [key, form] of Object.entries(forms)) {
          finalForm.push({
            id: form.layer,
            label: this.$i18n.tc(form.name_translation, 1)
          });
        }

        this.forms = finalForm;
      } catch (e) {
        console.error(e);
      }
    },

    getInputTypeName(input_type) {
      let item = this.fieldTypes.find(type => type.id === input_type);
      return item.label;
    },

    getObjectTypeName(object_type, table) {
      if (object_type) {
        let families = this.objectsAndMaterialFamilies;
        let family = families.find(item => item.id === object_type);
        return family ? family.label : object_type;
      } else {
        let form = this.forms.find(item => item.id === table);
        return form ? form.label : table;
      }
    },

    getFieldSize(field_size) {
      if (field_size) {
        let sizes = this.customFieldSizeOptions;
        let size = sizes.find(item => item.id === field_size);
        return size ? size.label : field_size;
      }
    },

    async getCustomLists(customField) {
      this.loading = true;
      try {
        const res = await this.fetchCustomLists();
        this.lists = res.data;
        this.lists.forEach(list => {
          const exists = this.customLists.find(custom => custom.id === list.name);
          if(!exists){
            this.customLists.push({
              id: list.name,
              label: list.name
            });
          }
        });

        if (customField && customField.list_name) {
          let listUuid = this.getListUuid(customField.list_name);
          if (listUuid) {
            this.getCustomList(listUuid);
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    getListUuid(listName) {
      if (this.lists.length > 0) {
        let list = this.lists.find(item => item.name === listName);
        return list ? list.uuid : listName;
      }
    },

    async getCustomList(listUuid) {
      this.loading = true;
      try {
        let list = await this.fetchCustomListByUuid(listUuid);
        list.entries.forEach(entry => {
          this.list.push({
            id: entry.code,
            label: entry.libelle ? entry.libelle : entry.code
          });
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    async getMaterialFamilies() {
      this.loading = true;
      try {
        let list = await this.GET_LIST({ listName: "list_material_family" });
        list.forEach(entry => {
          this.alternativeMaterialFamiliesList.push({
            id: entry.code,
            label: entry.name
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/customFieldsMixin.js